import Conversation from './../models/Conversation';
import Base from './Base';

export default class Conversations extends Base {
    get models() {
        const collection = this.data.map(item => new Conversation(item));
        collection.collection = this;

        return collection;
    }
}
